import Cookies from 'js-cookie';

import { getLocal, setLocal } from '@laigu/utils/storage';

const localKey = 'agentMarkData';
export const getLocalMarkData = () => {
  const userId = Cookies.get('_agent_id');
  const entId = Cookies.get('_enterprise_id');
  const markKey = `user${userId}_entId${entId}`;

  const agentMarkData = getLocal(localKey) || {};
  let markedConvId = [];
  if (agentMarkData) {
    markedConvId = agentMarkData[markKey] || [];
  }
  return markedConvId;
};

export const setLocalMarkData = convIds => {
  const userId = Cookies.get('_agent_id');
  const entId = Cookies.get('_enterprise_id');
  const markKey = `user${userId}_entId${entId}`;

  let agentMarkData = getLocal(localKey);
  if (!agentMarkData) {
    setLocal(localKey, {});
    agentMarkData = getLocal(localKey);
  }
  // 限制置顶最大数量999
  if (convIds.length > 999) {
    convIds.splice(0, convIds.length - 999);
  }
  agentMarkData[markKey] = convIds;

  setLocal(localKey, agentMarkData);
};
